<h2 *ngIf="sessionStarting">Starting session...</h2>
<h2 *ngIf="missingToken">Authentication token is required.</h2>
<h2 *ngIf="authFailed">Unable to authenticate.</h2>
<div *ngIf="errorMessage">
    <h2>Something went wrong while trying to create and start the session.</h2>
    <p>{{errorMessage}}</p>
</div>
